import verge from 'verge'

// document
const {body} = document
const html = document.documentElement

// easing
/* eslint-disable */
const easing = {
  inOutCubic: (x, t, b, c, d) => {
    if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b
    return (c / 2) * ((t -= 2) * t * t + 2) + b
  },
  outCubic: (x, t, b, c, d) => c * ((t = t / d - 1) * t * t + 1) + b,
}
/* eslint-enable */

// timer
let timer
export const stop = () => clearTimeout(timer)

// viewport
const getViewportH = () => verge.viewportH()

// scroll
const getCurrentScrollY = () => window.pageYOffset

const DOWNWARDS = 'downwards'
const UPWARDS = 'upwards'
const scrolledPastTarget = (target, direction) =>
  direction === UPWARDS ? getCurrentScrollY() <= target : getCurrentScrollY() >= target

// site header
export const getSiteHeaderHeight = () => document.querySelector('.js-header')?.offsetHeight ?? 0

export const getHelloBarHeight = () => document.querySelector('.c-hello-bar')?.offsetHeight ?? 0

// settings
const defaultSettings = {
  offset: 0,
}

export const scrollTo = (el, userSettings = {}) => {
  // settings
  const settings = Object.assign({}, defaultSettings, userSettings)

  // time
  const startTime = Date.now()

  // curr
  const startY = getCurrentScrollY()

  // el
  const elTop = Math.round(el.getBoundingClientRect().top) + startY + settings.offset + 1 // usually better to be one over than one under

  // document
  const documentBottom = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight,
  )

  // target
  const viewportH = getViewportH()
  const maxY = documentBottom - viewportH
  const direction = elTop > startY ? DOWNWARDS : UPWARDS
  const targetY = direction === DOWNWARDS && elTop > maxY ? maxY : elTop

  // duration
  const deltaY = targetY - startY
  const duration = Math.floor(100 * Math.log(Math.abs(deltaY))) + 100

  const step = () => {
    const elapsedTime = Date.now() - startTime
    window.scrollTo(0, easing.inOutCubic(0, elapsedTime, startY, deltaY, duration))

    if (elapsedTime > duration || scrolledPastTarget(targetY, direction)) {
      return cancelAnimationFrame(timer)
    }
    timer = requestAnimationFrame(step)
    return timer
  }
  step()
}

export const scrollToTop = () => scrollTo(document.documentElement)
